export default __webpack_public_path__ + "static/6_26-0e9a0683ab6321301cd580ec7e0a78c0.png";